import { render, staticRenderFns } from "./need-item-product.vue?vue&type=template&id=b1cc8920&scoped=true&"
import script from "./need-item-product.vue?vue&type=script&lang=js&"
export * from "./need-item-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1cc8920",
  null
  
)

export default component.exports